import { logs, SeverityNumber } from '@opentelemetry/api-logs';
import { ILogObjMeta, Logger as TSLogger } from 'tslog';

// TODO: upgrade to logger v5+ https://tslog.js.org/migration-v4-to-v5/ to use pre-made OTEL libs
const otelLogger = logs.getLogger('gui-tslog-bridge', __APP_VERSION__);
// maps tslog's log levels to otel's log levels
const tsLogOtelSeverity: Record<number, { severity: SeverityNumber; text: string }> = {
	0: { severity: SeverityNumber.TRACE, text: 'TRACE' },
	1: { severity: SeverityNumber.TRACE, text: 'TRACE' },
	2: { severity: SeverityNumber.DEBUG, text: 'DEBUG' },
	3: { severity: SeverityNumber.INFO, text: 'INFO' },
	4: { severity: SeverityNumber.WARN, text: 'WARN' },
	5: { severity: SeverityNumber.ERROR, text: 'ERROR' },
	6: { severity: SeverityNumber.FATAL, text: 'FATAL' },
};

const Logger = new TSLogger({
	prettyLogTemplate: 'PROM-GUI | {{rawIsoStr}}\t{{logLevelName}}\t',
	prettyErrorTemplate: '\n{{errorName}} {{errorMessage}}\nStack:\n{{errorStack}}',
	prettyErrorStackTemplate: '  • {{fileName}}\t{{method}}\n\t{{filePathWithLine}}',
	prettyErrorParentNamesSeparator: ':',
	prettyErrorLoggerNameDelimiter: '\t',
	stylePrettyLogs: true,
	prettyLogTimeZone: 'UTC',
	prettyLogStyles: {
		logLevelName: {
			'*': ['bold', 'black', 'bgWhiteBright', 'dim'],
			SILLY: ['bold', 'white'],
			TRACE: ['bold', 'whiteBright'],
			DEBUG: ['bold', 'green'],
			INFO: ['bold', 'blue'],
			WARN: ['bold', 'yellow'],
			ERROR: ['bold', 'red'],
			FATAL: ['bold', 'redBright'],
		},
		dateIsoStr: 'white',
		filePathWithLine: 'white',
		name: ['white', 'bold'],
		nameWithDelimiterPrefix: ['white', 'bold'],
		nameWithDelimiterSuffix: ['white', 'bold'],
		errorName: ['bold', 'bgRedBright', 'whiteBright'],
		fileName: ['yellow'],
	},
});

//only show warnings and errors in prod
if (import.meta.env.PROD) {
	Logger.settings.minLevel = 4;
} else {
	Logger.settings.minLevel = 1;
}

// possibly can be removed when tslog upgrade to v5, but might want to keep in to allow custom population of attributes
Logger.attachTransport((logObj: ILogObjMeta) => {
	// _logMeta in v5
	const meta = logObj._meta || {};
	const levelId = meta.logLevelId ?? 3;
	const levelName = meta.logLevelName || 'INFO';

	const { severity, text } = tsLogOtelSeverity[levelId] || {
		severity: SeverityNumber.INFO,
		text: 'INFO',
	};

	otelLogger.emit({
		severityNumber: severity,
		severityText: text,
		body: JSON.stringify(logObj),
		attributes: {
			'log.level': levelName.toLocaleLowerCase(),
		},
	});
});

export default Logger;
